export const ENV = 'prod'

export const GENERIC_URL = {
  local: {
    api: 'http://localhost:6633/',
  },
  sit: {
    api: 'https://api.pgs-demo.com/'
  },
  prod: {
    api: 'https://api.pgf-asw0zzz.com/'
  }
}
export const BASE_URL = GENERIC_URL[ENV].api
export const M_GET = 'GET'
export const M_POST = 'POST'
export const M_PUT = 'PUT'

export const WINLOSE_RESULT = 'game/result'
export const GET_GAME = 'result/fetchgame'